import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Функция рендера приложения
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

// Если i18n уже инициализирован - рендерим сразу
if (i18n.isInitialized) {
  console.log('✅ i18n already initialized, rendering app...');
  renderApp();
} else {
  // Иначе ждем события инициализации
  console.log('⏳ Waiting for i18n initialization...');
  i18n.on('initialized', () => {
    console.log('✅ i18n initialized, rendering app...');
    renderApp();
  });
}